<template>
  <ErrorLayout>
    <p>ベネフィット・ステーションは契約対象外のためご利用いただけません。</p>
    <p>利用対象サービスをご所属団体のご担当者様へご確認ください。</p>
    <p>他サービスのログイン画面は下記をご確認ください。</p>
    <a :href="bsLoginURL">{{ bsLoginURL }}</a>
  </ErrorLayout>
</template>

<script>
import ErrorLayout from '@/views/pages/ErrorLayout/index.vue';

export default {
  components: {
    ErrorLayout,
  },
  data(){
    return {
      bsLoginURL: "https://bs.benefit-one.inc/contents/beneacc/"
    }
  },
};
</script>

<style lang="scss"></style>
